import { Item } from '../../admin/models/item';
import { StripePaymentProcessor } from "./stripe-payment-processor.service";
import { HTTPService } from "./http.service";
import { AssessmentTokenService } from "./assessment-token.service";
import { OrderService } from "./order.service";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DacConfig } from 'app/shared/services/dac-config.service';
var ShoppingService = /** @class */ (function () {
    function ShoppingService(stripe, tokenService, http, orderService, dacConfig) {
        this.stripe = stripe;
        this.tokenService = tokenService;
        this.http = http;
        this.orderService = orderService;
        this.dacConfig = dacConfig;
        this._cartItems = [];
        this._shopItems = [];
        this._singleItemCheckout = false;
        this._checkoutStatus = new BehaviorSubject("PRE_ORDER");
    }
    Object.defineProperty(ShoppingService.prototype, "hasItems", {
        get: function () {
            return this._cartItems && this._cartItems.length;
        },
        enumerable: true,
        configurable: true
    });
    ShoppingService.prototype.hydrateItem = function (i) {
        var _this = this;
        if (!i) {
            return new Item();
        }
        var subItems = [];
        if (i.subItems) {
            subItems = i.subItems.map(function (subItem) { return _this.hydrateItem(subItem); })
                .filter(function (i) { return !i.assessment_uid || _this.dacConfig.isAssessmentEnabled(i.assessment_uid); });
        }
        var item = Object.assign(new Item(), i);
        item.subItems = subItems;
        return item;
    };
    ShoppingService.prototype.getItemForAssessment = function (item) {
        return this.getAvailableItems().then(function (items) {
            return items.find(function (i) { return i.assessment_uid == item.uid; });
        });
    };
    ShoppingService.prototype.getItemForAssessmentGroup = function (item) {
        return this.getAvailableItems().then(function (items) {
            // can we really key off the name?? That seems risky...
            return items.find(function (i) { return i.name == item.name && i.assessment_uid == null; }); // I don't think these are the same...?
        });
    };
    ShoppingService.prototype.startSingleCheckoutOrder = function (checkoutReturnUrl) {
        this._singleItemCheckout = true;
        this._singleItemCheckoutReturnUrl = checkoutReturnUrl;
    };
    ShoppingService.prototype.isSingleCheckoutOrder = function () {
        return this._singleItemCheckout;
    };
    ShoppingService.prototype.endSingleItemCheckout = function () {
        this._singleItemCheckout = false;
        this._singleItemCheckoutReturnUrl = null;
        // if there is anything in the cart we want to empty it.
        this.emptyCart();
        this._checkoutStatus.next("ORDER_CANCELLED");
    };
    ShoppingService.prototype.getSingleItemCheckoutReturnUrl = function () {
        return this._singleItemCheckoutReturnUrl;
    };
    ShoppingService.prototype.getAvailableItems = function () {
        var _this = this;
        return this.http.get("/items/").then(function (response) {
            var responseItems = response.json();
            console.log(responseItems);
            return responseItems.map(function (i) { return _this.hydrateItem(i); }).filter(function (i) { return !i.assessment_uid || _this.dacConfig.isAssessmentEnabled(i.assessment_uid); });
        });
    };
    ShoppingService.prototype.addItemToCart = function (item) {
        var _this = this;
        // even though this is synchronous it could become async so we are going to promisify it.
        return new Promise(function (resolve, reject) {
            var existingItem = _this._cartItems.find(function (i) { return i.id === item.id; });
            if (existingItem) {
                existingItem.quantity += item.quantity;
            }
            else {
                // push a copy.
                _this._cartItems.push(Object.assign(new Item(), item));
            }
            resolve();
        });
    };
    ShoppingService.prototype.removeItemFromCart = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._cartItems = _this._cartItems.filter(function (i) { return i.id !== item.id; });
            resolve();
        });
    };
    Object.defineProperty(ShoppingService.prototype, "cartItems", {
        get: function () {
            return this._cartItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShoppingService.prototype, "cartTotal", {
        get: function () {
            // let sum = 0.0;
            var sum = this._cartItems.reduce(function (a, b) { return a + b.totalPrice; }, 0);
            return +(sum).toFixed(2); // make sure we round correctly same as on server.
        },
        enumerable: true,
        configurable: true
    });
    ShoppingService.prototype.getCheckoutStatus = function () {
        return this._checkoutStatus;
    };
    ShoppingService.prototype.checkout = function (useSavedCard) {
        var _this = this;
        var items = this._cartItems.map(function (i) { return { "id": i.id, "quantity": i.quantity }; });
        this._checkoutStatus.next("ORDER_START");
        // we can't just send a raw array or else the token doesn't pass through.
        return this.http.post("/orders/", { items: items }).then(function (response) {
            var order = response.json();
            console.log("order created", order);
            // return order;
            if (order.total <= 0) {
                return _this.handleFreeOrder(order);
            }
            else {
                return _this.handlePaidOrder(order, useSavedCard);
            }
        });
    };
    ShoppingService.prototype.handleFreeOrder = function (order) {
        var data = {
            pmtProcessorToken: "FREE"
            // pmtProcessorToken: "blah"
            ,
            orderId: order.id
        };
        return this.purchaseTokens(data);
    };
    ShoppingService.prototype.handlePaidOrder = function (order, useSavedCard) {
        var _this = this;
        var amount = order.total * 100;
        this._checkoutStatus.next("PAYMENT_PREPARE");
        var stripeCharge;
        if (useSavedCard) {
            stripeCharge = Promise.resolve({ orderId: order.id, useSavedCard: useSavedCard });
        }
        else {
            stripeCharge = this.stripe.charge(amount, "Assessments")
                .then(function (token) {
                var data = {
                    pmtProcessorToken: token
                    // pmtProcessorToken: "blah"
                    ,
                    orderId: order.id,
                    useSavedCard: useSavedCard
                };
                return data;
            });
        }
        return stripeCharge.then(function (chargeData) {
            _this._checkoutStatus.next("ORDER_FINALIZE");
            return _this.purchaseTokens(chargeData);
        });
    };
    ShoppingService.prototype.emptyCart = function () {
        this._cartItems = [];
    };
    ShoppingService.prototype.purchaseTokens = function (data) {
        var _this = this;
        return this.http.post("/tokens/purchase", data).then(function (response) {
            _this._checkoutStatus.next("ORDER_COMPLETE");
            var purchaseResult = response.json();
            _this.orderService.storeLastOrder(purchaseResult.order);
            _this.emptyCart();
            console.log("purchase complete navigate to order page");
            return purchaseResult.order;
        });
    };
    return ShoppingService;
}());
export { ShoppingService };



// WEBPACK FOOTER //
// ./src/app/shared/services/shopping.service.ts.pre-build-optimizer.js